<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_ptb0lr24 s_bf">
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">
          <a-button size='small' @click="()=>{$router.go(-1)}" class="mr10">
            <LeftOutlined />返回
          </a-button>
          订单操作
        </p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35 s_fonts16"><span class="m-r-15">售后状态：{{orderData.refund_status_texts}}</span><span>订单号：{{orderData.order_no}} </span></p>
          <a-divider v-if='orderData.status == 0 || orderData.status == 1 || orderData.status==7 ||orderData.order_old_status == 4 || orderData.order_old_status == 2 || orderData.order_old_status == 3' />
          <div class="s_flex_ali mt10" v-if='orderData.status == 0 || orderData.status == 1 || orderData.status==7 ||orderData.order_old_status == 4 || orderData.order_old_status == 2 || orderData.order_old_status == 3'>
            <p class="m-r-15">你可以：</p>
            <!-- 7 退货 -->
            <div v-if="orderData.status!=7">
            <a-button class="m-r-15" type="primary" v-has:orderReturnShip='orderDeliver' v-if='orderData.status == 0 && orderData.delivery_type == 1'>标记发货</a-button>
            <a-button class="m-r-15" type="primary" v-has:orderReturnReturn='orderRefunds'>{{orderData.status == 0?'退款操作':'再次退款'}}</a-button>
            </div>
            <!-- 确认退款 -->
            <a-button class="m-r-15" type="primary" v-else v-has:orderReturnConfirm="()=>{confirmShow=true}">收到退货商品</a-button>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_old_status == 4 || orderData.order_old_status == 2 || orderData.order_old_status == 3) && orderData.delivery_type == 1' v-has:orderReturnLogistics='getLogistics'>物流信息</a-button>
          </div>
          
        </div>
      </div>
   
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">售后申请详情</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">处理方式：{{orderData.refund_type_text}}</p>
          <p class="s_c333  s_lin_h35">申请原因：{{orderData.apply_reason}}</p>
          <p class="s_c333  s_lin_h35">退款金额：¥{{orderData.refund_money}}</p>
          <p class="s_c333  s_lin_h35">手机号码：{{orderData.phone}}</p>
          <p class="s_c333  s_lin_h35">备注信息：{{orderData.apply_desc}}</p>
          <p class="s_c333  s_lin_h35">
            上传凭证：
            <a-image-preview-group>
              <a-image class="m-r-10" v-for='(item,index) in orderData.refund_images' :key='index' :width="100" :src="info.picdomain+item" />
            </a-image-preview-group>
          </p>
          <a-divider />
          <p class="s_c333 s_fonts14  m-b-20">买家信息：</p>
          <div class="s_flex_bian_c">
            <p class="width30 s_c333 ">微信昵称：{{orderData.member_name}}</p>
            <p class="width30 s_c333 ">会员ID：{{orderData.user_id}}</p>
            <p class="width30 s_c333 ">会员等级：{{orderData.vip_level}}</p>
          </div>
          <a-divider />
          <p class="s_c333 s_fonts14  m-b-20">商品清单：</p>
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsGood' :data-source='orderData.product_list'>
            <template v-slot:good="{ record }">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px">
                </template>
                <template #description>
                  <p class="s_omit">{{record.product_name}}</p>
                </template>
              </a-card-meta>
            </template>
            <template v-slot:product_price="{ record }">
              <p>{{record.product?record.product.product_price : '-'}}</p>
            </template>
            <template v-slot:coupon_price="{ record }">
              <p>{{record.coupon_price || '-'}}</p>
            </template>
          </a-table>
          <div class="s_flex_bian m-t-25">
            <div class="s_c333 ">
              <span class="m-r-20">商品数量总计：{{allNum}} </span><span>总重量：{{allWeight}}KG</span>
            </div>
            <div class="s_c333 ">
              <p class="m-b-15">商品总金额：¥{{orderData.total_price}}</p>
              <p class="m-b-10"> 运费：¥ {{orderData.freight_price}}</p>
              <p>订单金额：¥ <span class="fz-20 s_cd41">{{orderData.pay_price}}</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="mb25" v-if='orderData'>
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">退款信息</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">退款金额：￥{{orderData.refund_money}}</p>
          <p class="s_c333  s_lin_h35">退款时间：{{orderData.create_time}}</p>
          <!-- 物流 -->
           <div v-if="refund_extract">
          <p class="s_c333  s_lin_h35">退货物流：{{refund_extract.express.name || '无'}}</p>
          <p class="s_c333  s_lin_h35">退款单号：{{refund_extract.express_no || '无'}}</p>
          <p class="s_c333  s_lin_h35">联系方式：{{refund_extract.phone || '无'}}</p>
        </div>
        </div>
        
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">操作记录</p>
        <div class="s_p24">
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsRecord' :data-source='orderData.operation_log'>
            <template v-slot:user="{ record }">
              <p>{{record.operator_type}}<span v-if='record.user'>：{{record.user.member_name}}</span></p>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <a-modal  :keyboard="false" title="退款" :width='600' centered :footer="null" v-model:visible="showRefunds" destroyOnClose>
      <refundsForem :refundsData='refundsData' type='more' v-on:submitrefunds='submitrefunds' is_refund></refundsForem>
    </a-modal>
    <a-modal  :keyboard="false" title="标记发货" :width='1300' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
      <deliverForem :deliverData='deliverData' :type='1' :isInsteadShip='1' v-on:submitdeliver='submitdeliver'></deliverForem>
    </a-modal>
     
     <!-- 退款确认 -->
     <a-modal  :keyboard="false" v-model:visible="confirmShow" title="退款" @ok="confirmRefunds" centered>
       <div>确定把退款金额返还给消费者？</div>
    </a-modal>
    <a-modal  :keyboard="false" title="物流信息" :width='800' centered :footer="null" v-model:visible="showLogistics" destroyOnClose>
      <logisticsDetails :data='logisticsData'></logisticsDetails>
    </a-modal>
  </a-layout>
</template>

<script>
import { LeftOutlined } from '@ant-design/icons-vue';
import { ref, onMounted, inject, reactive, toRefs } from 'vue';
import { message } from 'ant-design-vue';
import store from '@/store';
import { getRefundMore,orderRefundFinal,getOrderLogistics } from '@/api/order';
import { iscode } from '@/utils/app';
import logisticsDetails from '../components/logisticsDetails'
export default {
  components: {
    LeftOutlined,logisticsDetails
  },
  setup() {
    const state = reactive({
      listLoading: false,
      showRefunds: false,
      showDeliver: false,
      showLogistics:false,
      deliverData: {},
      refundsData: {},
      info: store.state.user.info,
      orderData: {},
      allNum: 0,
      allWeight: 0,
      confirmShow:false,
      logisticsData:{},
      refund_extract:{
        express:{}
      } //物流信息
    });
    let columnsGood = [
      {
        title: '商品信息',
        key: 'good',
        slots: { customRender: 'good' },
      },
      {
        title: '数量',
        dataIndex: 'buy_num',
        key: 'buy_num',
      },
      {
        title: '售价',
        dataIndex: 'product_price',
        key: 'product_price',
        slots: { customRender: 'product_price' },
      },
      {
        title: '优惠',
        dataIndex: 'coupon_price',
        key: 'coupon_price',
        slots: { customRender: 'coupon_price' },
      },
      {
        title: '小计',
        dataIndex: 'total_pay_price',
        key: 'total_pay_price',
      },
    ];
    let columnsRecord = [
      {
        title: '操作时间',
        dataIndex: 'create_time',
        key: 'create_time',
      },
      {
        title: '操作人',
        dataIndex: 'user',
        key: 'user',
        slots: { customRender: 'user' },
      },
      {
        title: '操作动作',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: '信息',
        dataIndex: 'remark',
        key: 'remark',
      },
    ];
    const $route = inject('$route');
    const $Modal = inject('$Modal');
    const $router = inject('$router');
    const _lodash = inject('_lodash');
    //打开退货弹窗
    const orderRefunds = () => {
      state.refundsData = {
        pay_price: state.orderData.pay_price,
        refund_money: state.orderData.refund_money,
        order_no: $route.query.id,
        status: state.orderData.status,
        delivery_type:state.orderData.delivery_type,
        logistic_type:state.orderData.logistic_type
      };
      state.showRefunds = true;
    };
    //退货
    const submitrefunds = async () => {
      state.showRefunds = false;
      initData();
    };
    //打开发货弹窗
    const orderDeliver = async (type) => {
      state.deliverType = type;
      state.deliverData = {
        order_no: $route.query.id,
      };
      state.showDeliver = true;
    };
    //发货
    const submitdeliver = async () => {
      state.showDeliver = false;
      initData();
    };
    //获取详情
    const initData = async () => {
      const hide = message.loading('正在加载中...', 0);
      state.listLoading = true;
      let res = await getRefundMore({ order_no: $route.query.id }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        var list = res.data.product_list || [];
        var num = 0;
        var product_weight = 0;
        for (var i in list) {
          num = +list[i].buy_num;
          product_weight =
            list[i].buy_num *
            (list[i].product ? list[i].product.product_weight : 0);
        }

        state.allNum = num || 0;
        state.allWeight = product_weight || 0;
        state.orderData = res.data;
        state.refund_extract = res.data.refund_extract;
      } else {
        message.error(res.msg);
      }

      state.listLoading = false;
      setTimeout(hide);
    };

    //确认退款
    const confirmRefunds = async function(){
       let res = await orderRefundFinal({order_no:state.orderData.order_no}).then(res=>res.data)
       if(iscode(res,true)){
          initData() //刷新
       }
       state.confirmShow = false
      
    }
    //获取物流信息
    const getLogistics = async() =>{
      let res = await getOrderLogistics({ order_no: $route.query.id }).then((res) => res.data).catch((error) => error);
      if (iscode(res)) {
        state.showLogistics = true;
        state.logisticsData = res.data;
      } else {
        message.error(res.msg);
      }
    }
    onMounted(() => {
      initData();
    });
    return {
      columnsRecord,
      columnsGood,
      ...toRefs(state),
      orderRefunds,
      submitrefunds,
      orderDeliver,
      submitdeliver,
      confirmRefunds,
      getLogistics
    };
  },
};
</script>
